import { useRef, useEffect } from "react";

export const useAbortController = () => {
  const abortControllerRef = useRef<AbortController | null>(null);

  const createNewAbortController = () => {
    // Cancelar el controlador anterior si existe
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    // Crear nuevo controlador
    abortControllerRef.current = new AbortController();
    return abortControllerRef.current.signal;
  };

  // Limpiar al desmontar
  useEffect(() => {
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  return { createNewAbortController };
};
